import React from 'react'

import { uspItem, uspTitle } from './UspItemComponent.module.css'

const UspItemComponent = ({
  activeClassName,
  extraClassName,
  onClick,
  title,
}) => {
  return (
    <div
      className={`${uspItem} ${activeClassName}`}
      onClick={onClick}
      onKeyUp={onClick}
      role="button"
      tabIndex="0"
    >
      <h3 className={`${uspTitle} ${extraClassName}`}>{title}</h3>
    </div>
  )
}

export default UspItemComponent
